import React, { useState, useEffect } from "react";
import api from "@api";

export function useSystemAppNameSelect(formValue: number) {
  const [selectedSystemAppName, setSelectedSystemAppName] = React.useState(0);
  const [systemAppNames, setSystemAppNames] = useState([]);
  const [isFetchingSystemAppNames, setFetchingSystemAppNames] = useState(false);

  useEffect(() => {
    setFetchingSystemAppNames(true);
    api.systemappname
      .getSystemAppNameForSelect()
      .then((response) => {
        let data: any = [];
        response.forEach((d: any) => {
          data = [
            ...data,
            {
              label: d.systemAppName,
              value: d.id,
            },
          ];
        });
        data = [
          {
            label: "No selection",
            value: 0,
          },
          ...data,
        ];
        setSystemAppNames(data);
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        setFetchingSystemAppNames(false);
      });
  }, []);

  useEffect(() => {
    if (systemAppNames.length !== 0) {
      if (formValue) {
        setSelectedSystemAppName(formValue);
      }
    }
    return () => {
      setSelectedSystemAppName(0);
    };
  }, [systemAppNames]);

  const handleSystemAppNameChange = (event: any) => {
    setSelectedSystemAppName(event.target.value);
  };

  return {
    systemAppNames,
    isFetchingSystemAppNames,
    selectedSystemAppName,
    setSelectedSystemAppName,
    handleSystemAppNameChange,
  };
}
